import React, { useState, Suspense } from 'react';
import { httpForgotPassword } from '../../Hooks/user/user.post.hooks';
import { PasswordOuterContianer } from './ForgotAndReset.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
// Lazy-load components
const PrimaryButton = React.lazy(
  () => import('../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const InputContainer = React.lazy(() => import('../../Components/Form/Input'));

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const forgotPass = async (e) => {
    e.preventDefault();
    setSuccess('');
    setErr('');
    const trimmedEmail = email.trim();
    if (trimmedEmail.length < 9 || !trimmedEmail.includes('@')) {
      setErr('Not a valid email');
      return;
    }
    try {
      let res = await httpForgotPassword(trimmedEmail);
      let data = await res.json();
      if (res.ok) {
        setSuccess('Password reset link has been sent to your email');
      } else {
        setErr(data.msg);
      }
    } catch (err) {
      setErr('An error has occurred');
    }
  };

  return (
    <>
      <HelmetHelper
        title="Forgot Password"
        description="Reset your password to regain access to your account."
        noIndex
      />
      <PasswordOuterContianer>
        <h2>Forgot Password</h2>
        <p>Enter your email address to receive a link to reset your password</p>
        {err && <p className="error">{err}</p>}
        {success && <p className="success">{success}</p>}
        <form>
          <Suspense fallback={<div>Loading input...</div>}>
            <InputContainer
              placeholder="yoda@safety.com"
              label="Email"
              value={email}
              name="email"
              onChange={handleChange}
            />
          </Suspense>
          <Suspense fallback={<div>Loading button...</div>}>
            <PrimaryButton functionName={forgotPass} span="Reset Password" />
          </Suspense>
        </form>
      </PasswordOuterContianer>
    </>
  );
};

export default ForgotPassword;
